module.exports = __webpack_public_path__ + "static/media/haunted.cadcc941.jpg";